// src/config.js
const AppConfig = {
    title: "مەلەفی هاوەی حاجی مەزەی تازە",
    paragraph: "…",
    img: "https://i.postimg.cc/cJvqjVM8/1cbcbe63-c4a6-4f65-822b-1ea9c51f38d4.jpg",
    url: "hawa",
    id: "54060826"
};

export default AppConfig;